import Model from './Model';

export default class Param extends Model {
  baseURL() {
    return '';
  }

  resource() {
    return 'params';
  }
}
